export const GET_CMP_USER_REPORT_START = "GET_CMP_USER_REPORT_START";
export const GET_CMP_USER_REPORT_SUCCESS = "GET_CMP_USER_REPORT_SUCCESS";
export const GET_CMP_USER_REPORT_FAILURE = "GET_CMP_USER_REPORT_FAILURE";